"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    text: 'Progress:',
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map